'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _effects = require('redux-saga/effects');

var _actions = require('./actions');

var _effects2 = require('./effects');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

var id = function id(a) {
  return a;
};

exports.default = function (actionType, apiFn) {
  var extraParamsEffects = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var takeEffect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _effects2.takeLatestAndCancel;
  var callApi = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _effects.call;
  var needEffect = arguments[5];
  var successEffects = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var failureEffects = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  var takeEffectArgs = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
  var mapLoadingAction = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : id;
  var mapSuccessAction = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : id;
  var mapFailureAction = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : id;

  var _marked =
  /*#__PURE__*/
  _regenerator2.default.mark(handleApi);

  var unloadTypes = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : [];
  var actionTypes = (0, _actions.makeActionTypes)(actionType);

  function handleApi(_ref) {
    var params = _ref.payload.params,
        meta = _ref.meta;
    var needToRun, finalParams, i, extraParams, data;
    return _regenerator2.default.wrap(function handleApi$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof needEffect === 'function')) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return needEffect(meta);

          case 3:
            needToRun = _context.sent;

            if (needToRun) {
              _context.next = 6;
              break;
            }

            return _context.abrupt('return');

          case 6:
            _context.next = 8;
            return (0, _effects.put)(mapLoadingAction({
              type: actionTypes.loading,
              meta: meta
            }));

          case 8:
            _context.prev = 8; // Get extra shit from outside HOOK

            finalParams = params;
            i = 0;

          case 11:
            if (!(i < extraParamsEffects.length)) {
              _context.next = 19;
              break;
            }

            _context.next = 14;
            return extraParamsEffects[i](finalParams, meta);

          case 14:
            extraParams = _context.sent;
            finalParams = Array.isArray(finalParams) ? finalParams = extraParams : finalParams = _extends({}, finalParams, extraParams);

          case 16:
            i++;
            _context.next = 11;
            break;

          case 19:
            // Run api using given call api function \w all the merged params
            data = void 0;

            if (!Array.isArray(finalParams)) {
              _context.next = 26;
              break;
            }

            _context.next = 23;
            return callApi.apply(undefined, [apiFn].concat(_toConsumableArray(finalParams)));

          case 23:
            data = _context.sent;
            _context.next = 29;
            break;

          case 26:
            _context.next = 28;
            return callApi(apiFn, finalParams);

          case 28:
            data = _context.sent;

          case 29:
            _context.next = 31;
            return (0, _effects.put)(mapSuccessAction({
              type: actionTypes.success,
              meta: meta,
              payload: {
                data: data,
                // Sha la la la
                params: finalParams
              }
            }));

          case 31:
            _context.next = 33;
            return (0, _effects.all)(successEffects.map(function (effect) {
              return effect(data, meta);
            }));

          case 33:
            _context.next = 43;
            break;

          case 35:
            _context.prev = 35;
            _context.t0 = _context['catch'](8);

            if (!(_context.t0 instanceof TypeError || _context.t0 instanceof RangeError || _context.t0 instanceof SyntaxError || _context.t0 instanceof ReferenceError)) {
              _context.next = 39;
              break;
            }

            throw _context.t0;

          case 39:
            _context.next = 41;
            return (0, _effects.put)(mapFailureAction({
              type: actionTypes.failure,
              payload: _context.t0,
              error: true,
              meta: meta
            }));

          case 41:
            _context.next = 43;
            return (0, _effects.all)(failureEffects.map(function (effect) {
              return effect(_context.t0, meta);
            }));

          case 43:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked, this, [[8, 35]]);
  }

  return (
    /*#__PURE__*/
    _regenerator2.default.mark(function watchApi() {
      return _regenerator2.default.wrap(function watchApi$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _effects.fork.apply(undefined, [takeEffect, actionTypes.main, [actionTypes.unload].concat(_toConsumableArray(unloadTypes)), handleApi].concat(_toConsumableArray(takeEffectArgs)));

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, watchApi, this);
    })
  );
};